module.exports = {
  home: require("./home"),
  project: require("./project"),
  footer: require("./footer"),
  contact: require("./contact"),
  landing: require("./landing"),
  passwordCreate: require("./passwordCreate"),
  passwordReset: require("./passwordReset")
};
